// src/components/Header.jsx
import React from 'react';
import { PRIMARY_FONT } from '../constants';

const Header = () => {
  return (
    <header className="relative z-20">
      <div className="h-24">
        <h1
          className="text-6xl lg:text-7xl lg:py-3 font-bold text-white text-center py-5 relative z-20 tracking-tight"
          style={{ fontFamily: PRIMARY_FONT }}
        >
          Ricky Zafiro
        </h1>
        <div className="flex justify-center -mt-3">
          <span className="font-handwritten text-sm text-white text-opacity-30 tracking-widest">
            ~ cuaderno de pruebas ~
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;
